import React from "react";
import { Column, Row, Text, Icon, Divider, Button } from "@amzn/meridian";
import checkLargeTokens from "@amzn/meridian-tokens/base/icon/check-large";
import chevronRightSmallTokens from "@amzn/meridian-tokens/base/icon/chevron-right-small";
import closeMediumTokens from "@amzn/meridian-tokens/base/icon/close-medium";
import { InspectionResult } from "src/services/inspectionService";
import "./CheckpointCard.scss";

export interface ComplianceResultRowProps {
    result: InspectionResult;
    index: number;
    onClick?: () => void;
}

const ComplianceResultRow: React.FC<ComplianceResultRowProps> = ({ result, index, onClick }) => {
    const label = `D${index + 1}`;
    const objectLabel = result.objectId || `Object-${index + 1}`;

    return (
        <Column>
            <Row
                alignmentHorizontal="justify"
                alignmentVertical="center"
                spacingInset="200 none"
            >
                <Row alignmentVertical="center" spacing="300">
                    <div
                        className={`status-circle ${result.isCompliant
                            ? "status-circle--compliant"
                            : "status-circle--non-compliant"
                            }`}
                    >
                        {result.isCompliant ? (
                            <Icon tokens={checkLargeTokens} color="success" />
                        ) : (
                            <Icon tokens={closeMediumTokens} color="error" />
                        )}
                    </div>
                    <Text type="h50" color="secondary">
                        {label}
                    </Text>
                    <Text type="b200" color="secondary">
                        {objectLabel}
                    </Text>
                </Row>
                <Button onClick={onClick} type="icon">
                    <Icon tokens={chevronRightSmallTokens} color="secondary" />
                </Button>
            </Row>
            <Divider />
        </Column>
    );
};

export default ComplianceResultRow;
